if (document.querySelector('.about-quiz')) {

    let count = 0;
    var lowRange, lowHeading, lowMessage, midHeading, midRange, midMessage, highHeading, highRange, highMessage;
    $(function () {

        $.getJSON(location.protocol + '//' + location.hostname + '/wp-content/themes/kings-nurses/dist/js/questions.json', function (data) {
        //$.getJSON('http://localhost/kings-nurses/wordpress/wp-content/themes/ps/dist/js/questions.json', function (data) {
            $.each(data.questions, function (i, f) {

                var quesId = f.questionID,
                    quesType = f.type,
                    nextQuesID = f.NextQuestionID,
                    question = f.title,
                    img = f.image,
                    desc = f.desc,
                    instructions = f.instructions,
                    totalOptions = f.responses.length,
                    responses = f.responses;

                switch (quesType) {
                    case 'singlechoice':
                        singleChoiceQuestion(quesId, quesType, nextQuesID, question, img, desc, instructions, totalOptions, responses, count);
                        break;
                    case 'multichoice':
                        multiChoiceQuestion(quesId, quesType, nextQuesID, question, img, desc, instructions, totalOptions, responses, count);
                        break;
                    case 'dragdrop':
                        dragDropQuestion(quesId, quesType, nextQuesID, question, img, desc, instructions, totalOptions, responses, count)
                        break;
                    case 'mostleastlikey':
                        mostLeastLikelyQuestion(quesId, quesType, nextQuesID, question, img, desc, instructions, totalOptions, responses, count)
                        break;
                }
                count++;
            });

            $.each(data.results, function (i, r) {

                if (i == 0) {
                    lowHeading = r.heading;
                    lowRange = r.rangeUpto;
                    lowMessage = r.message;
                    lowCtaText = r.ctaText;
                    lowCtaLink = r.ctaLink;
                } else if (i == 1) {
                    midHeading = r.heading;
                    midRange = r.rangeUpto;
                    midMessage = r.message;
                    midCtaText = r.ctaText;
                    midCtaLink = r.ctaLink;
                } else if (i == 2) {
                    highHeading = r.heading;
                    highRange = r.rangeUpto;
                    highMessage = r.message;
                    highCtaText = r.ctaText;
                    highCtaLink = r.ctaLink;
                }

            });

        });

    });

    //For Single Choice Question
    function singleChoiceQuestion(quesId, quesType, nextQuesID, question, img, desc, instructions, totalOptions, responses, count) {

        var quesContainer = $("<div class='question tab' tabindex='0'></div>");
        $(quesContainer).appendTo(".questions");

        var tblRow = `<div class="single-choice">
      <div class="question-image"><img src="${img}" /></div>  
      <p class="question-title">${question}</p>
      <p class="ques-desc">${desc}</p>
      <p class="instruction">${instructions} <span>(Choose one option, and then press Next)</span></p>

      <ul class="options options-${quesId}" role="radiogroup"></ul></div>`;
        //</div></div>`;

        $(tblRow).appendTo(quesContainer);

        for (var i = 0; i < totalOptions; i++) {
            var opt = `<li class="option" role="radio" aria-checked="false">         
            <input type="radio" name="single-choice-${count}" id="option-${i + 1}-${count}" value="${responses[i].score}" required="required">
            <label for="option-${i + 1}-${count}" tabindex='0'>${responses[i].responseText}</label>
        </li>`;

            $(opt).appendTo($('.options-' + quesId));
        }


    }

    //For Multichoice Choice Question
    function multiChoiceQuestion(quesId, quesType, nextQuesID, question, img, desc, instructions, totalOptions, responses, count) {
        var quesContainer = $("<div class='question tab' tabindex='0'></div>");
        $(quesContainer).appendTo(".questions");

        var tblRow = `<div class="multiselect">
      <div class="question-image"><img src="${img}" /></div>  
      <p class="question-title">${question}</p>
      <p class="ques-desc">${desc}</p>
      <p class="instruction">${instructions}<span>(Please choose all that applies, and then press Next)</span></p>
      <ul class="options options-${quesId}"></ul></div>`;

        $(tblRow).appendTo(quesContainer);

        for (var i = 0; i < totalOptions; i++) {
            var opt = `<li class="option">                    
                    <input type="checkbox" name="multiselect-${count}" id="option-${i + 1}-${count}" value="${responses[i].score}" aria-checked="false">
                    <label for="option-${i + 1}-${count}" tabindex='0'>${responses[i].responseText}</label>
                  </li>`;

            $(opt).appendTo($('.options-' + quesId));
        }


    }

    //For Drag Drop Question
    function dragDropQuestion(quesId, quesType, nextQuesID, question, img, desc, instructions, totalOptions, responses, count) {

        var quesContainer = $("<div class='question tab' tabindex='0'></div>");
        $(quesContainer).appendTo(".questions");

        var tblRow = '<div class="drag-drop">' +
            '<div class="question-image"><img src="' + img + '" /></div>' +
            '<p class="question-title">' + question + '</p>' +
            '<p class="ques-desc">' + desc + '</p>' +
            '<p class="instruction">' + instructions + '<span>(Please drag to place the statements in order of the most like you [1], to least like you [3])</span></p>' +

            '<div class="options">' +
            '<div class="col-left">' + '</div>' +
            '<div class="col-right">' +

            '</div>' +
            '</div>' +
            '</div>';

        $(tblRow).appendTo(quesContainer);

        for (var i = 0; i < totalOptions; i++) {
            var opt = `<div class="droptarget from" ondrop="drop(event)" ondragover="allowDrop(event)" tabindex="0">
                    <p ondragstart="dragStart(event)" ondrag="dragging(event)" draggable="true" id="dragtarget${i}" score="${responses[i].score}" correct-rank="${responses[i].correctRank}">${responses[i].responseText}</p>
                  </div>`;
            var spaces = `<div class="droptarget to" ondrop="drop(event)" ondragover="allowDrop(event)" tabindex="0" data-block="${i + 1}"></div>`;

            $(opt).appendTo($('.col-left'));
            $(spaces).appendTo($('.col-right'));
        }


    }

    //For Most Least Likely Question
    function mostLeastLikelyQuestion(quesId, quesType, nextQuesID, question, img, desc, instructions, totalOptions, responses, count) {

        var quesContainer = $("<div class='question tab' tabindex='0'></div>");
        $(quesContainer).appendTo(".questions");

        var tblRow = `<div class="mostleastlikey">
      <div class="question-image"><img src="${img}" /></div>  
      <p class="question-title">${question}</p>
      <p class="ques-desc">${desc}</p>
      <p class="instruction">${instructions} <span>(Please choose what you think the most effective action and the least effective action would be, and then press Next)</span></p>

      <div class="most-least-options options-${quesId}"> 
        <div class="option-row option-row-header">
            <div class="option-col1">Possible actions</div>
            <div class="option-col2">Most effective</div>
            <div class="option-col3">Least effective</div>
        </div>  
        <ul class="options-list-${quesId}"></u>              
      </div>
    </div>`;

        $(tblRow).appendTo(quesContainer);

        for (var i = 0; i < totalOptions; i++) {
            var opt = `<li class="option-row" tabindex="0" role="radiogroup">
            <div class="option-col1">${responses[i].responseText}</div>
            <div class="option-col2" tabindex='0' role="radio" aria-checked="false"><input type="radio" name="option-row${i}" id="option-${quesId}-row${i}-most" value="${responses[i].most}"><label for="option-${quesId}-row${i}-most">Most Effective</label><div class="check"></div></div>
            <div class="option-col3" tabindex='0' role="radio" aria-checked="false"><input type="radio" name="option-row${i}" id="option-${quesId}-row${i}-least" value="${responses[i].least}"><label for="option-${quesId}-row${i}-least">Least Effective</label><div class="check"></div></div>
        </li>`;

            $(opt).appendTo($('.options-list-' + quesId));
        }
    }


    var buttons = ` <div style="overflow:auto;">
<div style="text-align: center;">
  <button type="button" id="prevBtn" onclick="nextPrev(-1)">Previous</button>
  <button type="button" id="nextBtn" onclick="nextPrev(1)">Next</button>
</div>
</div>`;

    let scores = [];
    var correctRank, blockNo;

    //DragDrop    
    function dragStart(event) {
        event.dataTransfer.setData("text", event.target.id);
        correctRank = event.target.getAttribute('correct-rank');
        correctScore = event.target.getAttribute('score');
    }

    function dragging(event) {
        //console.log('The p element is being dragged');
    }

    function allowDrop(event) {
        event.preventDefault();
    }

    function drop(event) {
        //event.preventDefault();
        //event.stopPropagation();

        if (event.target.childNodes.length != 0 && event.target.childNodes.length != 2) {
            return false;
        } else {
            //console.log('moved');
        }

        var data = event.dataTransfer.getData("text");
        blockNo = event.target.getAttribute("data-block");

        event.target.appendChild(document.getElementById(data));
        //console.log('The p element was dropped');   
        $('#nextBtn').attr('disabled', false);
    }

    //Start Quiz
    function startQuiz() {
        $('.about-quiz').fadeOut(100);
        $('.quiz-started').delay(100).fadeIn();
        $(buttons).appendTo($('.questions'));
        showTab(currentTab);

        $('#nextBtn').attr('disabled', true);

        $('.option label').on('keydown', function (e) {
            if ((e.keyCode ? e.keyCode : e.which) == 13) {
                $(this).trigger('click');
                $('#nextBtn').attr('disabled', false);
            }
        });

        $('.options').on('click touchstart', '.option label', function () {
            $('#nextBtn').attr('disabled', false);
            $(this).parent().parent().find('.option').attr('aria-checked', false);
            $(this).parent().attr('aria-checked', true);
        })

        //Most & Least Likely Question 
        $('.option-row .option-col2, .option-row .option-col3').on('keydown', function (e) {
            if ((e.keyCode ? e.keyCode : e.which) == 13) {
                $(this).find('label').trigger('click');

                if ($(this).parent().parent().find('input:checked').length == 2) {
                    $('#nextBtn').attr('disabled', false);
                }

            }
        });


        $('.option-row .option-col2, .option-row .option-col3').on('click touchstart', function () {
            $(this).parent().find('.option-col2, .option-col3').attr('aria-checked', false);

            if ($(this).hasClass('option-col2')) {
                $(this).parent().parent().find('.option-col2').attr('aria-checked', false);
            } else if ($(this).hasClass('option-col3')) {
                $(this).parent().parent().find('.option-col3').attr('aria-checked', false);
            }

            $(this).attr('aria-checked', true);

            if ($(this).parent().parent().find('input:checked').length == 2) {
                $('#nextBtn').attr('disabled', false);

            }
        })

        // $('.most-least-options').on('click', '.option-col2', function () {
        // })

        $('.options').each(function (index) {
            var totalOptions = $(this).find('.option').length;
            $(this).addClass('totalOptions-' + totalOptions);
        })
    }



    var x, currentTab = 0, totalScore;

    function showTab(n) {

        x = document.getElementsByClassName("tab");
        x[n].style.display = "block";
        x[n].focus();

        if (n == 0) {
            document.getElementById("prevBtn").style.display = "none";
        } else {
            document.getElementById("prevBtn").style.display = "inline";
        }
        if (n == (x.length - 1)) {
            document.getElementById("nextBtn").innerHTML = "Submit";
        } else {
            document.getElementById("nextBtn").innerHTML = "Next";
        }

        document.querySelector(".current-ques").innerHTML = n + 1;
        document.querySelector(".total-ques").innerHTML = count;


        $('.most-least-options').on('click', '.option-col2', function () {
            var mostLeastQues = $(this).parent().parent().parent().parent();
            mostLeastQues.find('.option-col2').find('input[type="radio"]').prop('checked', false);
            $(this).find('input[type="radio"]').prop('checked', true);
        })

        $('.most-least-options').on('click', '.option-col3', function () {
            var mostLeastQues = $(this).parent().parent().parent().parent();
            mostLeastQues.find('.option-col3').find('input[type="radio"]').prop('checked', false);
            $(this).find('input[type="radio"]').prop('checked', true);
        })

    }

    function nextPrev(n) {

        x[currentTab].style.display = "none";
        currentTab = currentTab + n;

        // if you have reached the end of the form...    
        if (currentTab >= x.length) {
            //document.getElementById("quiz").submit();
            calculateResults();
            return false;
        }

        // Otherwise, display the correct tab:
        showTab(currentTab);

        if (n == -1) {
            $('#nextBtn').attr('disabled', false);
        } else {
            $('#nextBtn').attr('disabled', true);
            var selectedOptions = Array.prototype.slice.call(x[currentTab].querySelectorAll('input'));

            selectedOptions.forEach(option => {
                if (option.checked) {
                    $('#nextBtn').attr('disabled', false);
                }
            })

        }

        $('html, body').animate({
            scrollTop: $(".questions").offset().top
        }, 50);

    }

    function calculateResults() {
        //console.log('calculate results');

        var quiz = document.getElementById('quiz');
        var allCheckedInputs = Array.prototype.slice.call(quiz.querySelectorAll('input:checked'));
        allCheckedInputs.forEach(inp => {
            scores.push(parseInt(inp.value));
        });

        var targetBlocks = Array.prototype.slice.call(document.querySelectorAll('.to'));

        targetBlocks.forEach(targetBlock => {
            var tarBlock = targetBlock.getAttribute('data-block');

            if (targetBlock.hasChildNodes()) {
                var dragBox = targetBlock.childNodes[0].getAttribute('correct-rank');

                if (tarBlock == dragBox) {
                    scores.push(parseInt(targetBlock.childNodes[0].getAttribute('score')));
                } else {
                    scores.push(0);
                }
            }
        });

        //Total Score 
        totalScore = scores.reduce(function (a, b) {
            return a + b;
        }, 0);

        updateResult();

        $('.quiz-details').fadeOut(5);
        $('.results').fadeIn(5);
        $('.quiz-started').fadeOut(100);
        $('.about-quiz').delay(100).fadeIn();
    }

    function updateResult() {
        //console.log(scores + ' - ' + totalScore);
        if (totalScore < lowRange) {
            // $('.assessment-heading').text(lowHeading);
            $('#result-text').text(lowMessage);
            $('#btn-result').attr('href', lowCtaLink).html(lowCtaText);
        } else if (totalScore > lowRange && totalScore < midRange) {
            //$('.assessment-heading').text(midHeading);
            $('#result-text').text(midMessage);
            $('#btn-result').attr('href', midCtaLink).html(midCtaText);
        } else if (totalScore > midRange && totalScore < highRange) {
            //$('.assessment-heading').text(highHeading);
            $('#result-text').text(highMessage);
            $('#btn-result').attr('href', highCtaLink).html(highCtaText);
        }
    }


}
document.onreadystatechange = () => {
    if (document.querySelector('.quiz-details')) {
        //console.log(document.readyState);

        if (document.readyState == 'complete') {
            let startBtn = document.querySelector('.start-quiz');
            startBtn.classList.remove('quiz-btn');
            startBtn.textContent = 'Start';
            startBtn.removeAttribute('disabled');
            startBtn.style.display = 'block';
        }
    }
};